export default __webpack_public_path__ + "c12ca28a3373f8dd390992bb511d9605.webp";